export default () => ({
  list: [],
  listForLs: [],
  lsTags: []
})
